import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { SnackBarService } from '@shared/services/snack-bar.service';
import { AuthService } from '../auth/auth.service';
@Injectable({
  providedIn: 'root',
})
export class HttpService {
  constructor(
    private http: HttpClient,
    private snackBarService: SnackBarService,
    public auth: AuthService
  ) {}
  public get<T>(path: string, options?: any): Observable<any> {
    return this.http
      .get<T>(`${path}`, options)
      .pipe(catchError(this.handleError.bind(this)));
  }

  public post<T>(path: string, body: any, options?: any): Observable<any> {
    return this.http
      .post<T>(`${path}`, body, options)
      .pipe(catchError(this.handleError.bind(this)));
  }

  public put<T>(path: string, body: any, options?: any): Observable<any> {
    return this.http
      .put<T>(`${path}`, body, options)
      .pipe(catchError(this.handleError.bind(this)));
  }

  public patch<T>(path: string, body: any, options?: any): Observable<any> {
    return this.http
      .patch<T>(`${path}`, body, options)
      .pipe(catchError(this.handleError.bind(this)));
  }

  public delete<T>(path: string, options?: any): Observable<any> {
    return this.http
      .delete<T>(`${path}`, options)
      .pipe(catchError(this.handleError.bind(this)));
  }

  // Error handling
  private handleError(error) {
    let errorMessage = 'Something went wrong, try again later.';
    if (error.status == 500) {
      this.snackBarService.openFailure(`${errorMessage}`, 'OK', {
        duration: 3000,
      });
    } else if (error.status >= 400 && error.status < 500) {
      errorMessage = error?.error?.errors[0]?.msgs[0];
      this.snackBarService.openFailure(`${errorMessage}`, 'OK', {
        duration: 3000,
      });

      if (error.status == 401) {
        this.auth.logout();
      }
    } else {
      this.snackBarService.openFailure(`${errorMessage}`, 'OK', {
        duration: 3000,
      });
    }
    return throwError(errorMessage);
  }
}
